module.exports = __webpack_public_path__ + "static/img/login_a2.d1af23a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/login/login_a2.png
// module id = qt/S
// module chunks = 23